<template>
    <span class="inline-flex items-center gap-1 px-1.5 py-px text-xs font-semibold capitalize" :class="textClass">
        {{ label }}
        <span class="size-1.5 rounded-full" :class="dotClass" />
    </span>
</template>

<script lang="ts" setup>
import { computed } from 'vue';

const props = defineProps<{
    status: 'active' | 'inactive';
}>();

const label = computed(() => (props.status === 'active' ? 'Active' : 'Inactive'));

const textClass = computed(() =>
    props.status === 'active' ? 'text-new-green-600' : 'text-[#ff720d]',
);

const dotClass = computed(() =>
    props.status === 'active' ? 'bg-new-green-600' : 'bg-[#ff720d]',
);
</script>
